export const DEPOSIT_BUTTON_OPENS_CONFIG_PATH = 'config.config.payments.depositButtonOpens';

export const DEPOSIT_BUTTON_OPENS = {
  PAGE: 'deposit_page',
  POPUP: 'deposit_popup',
};

export const DEPOSIT_POPUP_NOTIFICATION_TYPE = 'depositPopup';

export const DEPOSIT_POPUP_NOTIFICATION_ID = 'depositPopup';


export const MULTIPLIER = 100;

export const DESCRIPTOR_KIND = {
  FORM: 'FORM',
  NONE: 'NONE',
  NOTIFICATION: 'NOTIFICATION',
  POPUP: 'POPUP',
  REDIRECT: 'REDIRECT',
  WINDOW: 'WINDOW',
};
